import React from 'react';
import SeedsHeaderWithNotifications from './SeedsHeaderWithNotifications';
import NavigationView from './NavigationView';

import './header-container.scss';

export default function HeadersContainer(props) {
    
    return (
        <div className="header-container">
            <SeedsHeaderWithNotifications user={props.user} />
            <NavigationView {...props} />
        </div>
    )
}